// Translations storage
let translations: ITranslation[] = [];

export interface ITranslation {
  slug: string,
  translation: string,
}

export function _t(slug: string, replace?: Object): string {
  const currentTranslation = translations.find(translation => translation.slug === slug)
  let translatedString = currentTranslation ? currentTranslation.translation : slug;

  if (typeof replace !== 'undefined') {
    Object.keys(replace).forEach(key => {
      translatedString = translatedString.replace(`{${key}}`, replace[key]);
    })
  }

  return translatedString;
}

export function getSlugByTranslation(translation: string): string {
  const translationItem = translations.find(item => item.translation.toLowerCase() === translation.toLowerCase())

  if (translationItem !== undefined ) {
    return translationItem.slug
  }

  return translation
}

export function setUpTranslations(newTranslations: ITranslation[]): void {
  translations = newTranslations;
}
